import { html } from "lit-html";

import fraELazyImageShadowScss from "./fra-e-lazy-image.shadow.scss";

type TemplateParameter = {
  src?: string;
  alt?: string;
  srcset?: string;
  sizes?: string;
  aspectRatio?: string;
  wrapper?: string;
  imageAlignment?: string;
};

const getWrapperClass = (wrapper: string | undefined) => {
  if (wrapper === "circle") return "fra-e-lazy-image--circle";
  return "";
};

const getAspectRatioClass = (aspectRatio: string | undefined) => {
  if (aspectRatio === "32:13") return "fra-e-lazy-image__mask fra-e-lazy-image__mask--32-13";
  if (aspectRatio === "21:9") return "fra-e-lazy-image__mask fra-e-lazy-image__mask--21-9";
  if (aspectRatio === "16:9") return "fra-e-lazy-image__mask fra-e-lazy-image__mask--16-9";
  if (aspectRatio === "4:3") return "fra-e-lazy-image__mask fra-e-lazy-image__mask--4-3";
  if (aspectRatio === "1:1") return "fra-e-lazy-image__mask fra-e-lazy-image__mask--1-1";
  if (aspectRatio === "cover") return "fra-e-lazy-image__no-ratio fra-e-lazy-image__cover";
  if (aspectRatio === "contain") return "fra-e-lazy-image__no-ratio fra-e-lazy-image__contain";
  return "fra-e-lazy-image__no-ratio";
};

export const FALLBACK_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 9'%3E%3C/svg%3E";

export const renderLazyImage = (args: TemplateParameter) => {
  return html`
    <style>
      ${fraELazyImageShadowScss}
    </style>
    <!--<div class="${getWrapperClass(args.wrapper)}">-->
    <div class="${getAspectRatioClass(args.aspectRatio)}">
      <div class="fra-e-lazy-image__wrapper fra-js-lazy-image__wrapper">
        <img
          draggable="false"
          class="fra-js-lazy-image__img fra-e-lazy-image__img"
          src="${args.src}"
          srcset="${args.srcset}"
          alt="${args.alt}"
          sizes="${args.sizes}"
          data-object-fit=${args.aspectRatio === "cover"}
        />
      </div>
    </div>
    <!--</div>-->
  `;
};
